<template>
  <p>
    {{ $t($slots.default[0].text ? $slots.default[0].text : '') }}
  </p>
</template>
<script>
export default {
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  created() { },
  mounted() { },
}
</script>
